import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/HomeView.vue'
import Sobre from '../views/SobreView.vue'
import Produto from '../views/ProdutoView.vue'
import ProdutoDetalhe from '../views/ProdutoDetalheView.vue'
import Blog from '../views/BlogView.vue'
import BlogDetalhe from '../views/BlogDetalheView.vue'
import Contato from '../views/ContatoView.vue'
import Informacoes from '../views/InformacoesView.vue'
import Representantes from '../views/RepresentantesView.vue'


const routes = [
 { path: '/', name: 'Home', component: Home },
 { path: '/sobre', name: 'Sobre', component: Sobre },
 { path: '/produto/:id/:nome', name: 'Produto', component: Produto },
 { path: '/produtodetalhe/:id/:nome', name: 'ProdutoDetalhe', component: ProdutoDetalhe },
 { path: '/blog', name: 'Blog', component: Blog },
 { path: '/blogdetalhe/:id/:nome', name: 'BlogDetalhe', component: BlogDetalhe },
 { path: '/contato', name: 'Contato', component: Contato },
 { path: '/informacoes/:id/:nome', name: 'Informacoes', component: Informacoes },
 { path: '/Representantes', name: 'Representantes', component: Representantes },
 
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
  next()
})

export default router